module.exports = __webpack_public_path__ + "img/europass-cv.2ec7352f.png";